<div class="modal-dsgvo-content">
  <app-loading-spinner [loading]="dsgvoText === ''">
    <div [innerHTML]="dsgvoText"></div>
  </app-loading-spinner>
</div>
<div class="modal-dsgvo-footer mt-4">
  <div *ngIf="dsgvoText !== ''" [ngStyle]="{'color': (confirmed==false) ? 'red' : null}">
    <div class="form-check">
      <input [(ngModel)]="confirmed" [id]="'modal-confirmed-' + uniqueId" type="checkbox" class="form-check-input">
      <label class="form-check-label" [attr.for]="'modal-confirmed-' + uniqueId">
        {{'LICENCE.ACCEPT_PRIVACY'|translate}}
      </label>
    </div>
  </div>
</div>
